import { apiGet, apiPut, apiDelete, apiPost } from "@redriver/cinnamon";

const NAMESPACE = "TAGINPUT";

const ActionTypes = {
  CheckTagEmailsValid: `${NAMESPACE}/CHECK_TAG_EMAILS_VALID`,
  SearchUsers: `${NAMESPACE}/SEARCH_USERS`,
};

// checks a batch of email addresses in one request - used for both a single
// typed email (as a one-element array) and a whole pasted list, so there's
// only one email-uniqueness check path to keep in sync with user creation
export const checkTagEmailsValid = (emails) => {
  return apiPost(ActionTypes.CheckTagEmailsValid, "users/valid-emails", emails);
};

export const searchUsers = (search, other = {}) => {
  return apiGet(
    ActionTypes.SearchUsers,
    `users/available`,
    {
      pageSize: 10,
      pageNumber: 1,
      search,
      ...other,
    },
    {
      debounce: 100,
    }
  );
};
